import { getAsYouType, parsePhoneNumber } from 'awesome-phonenumber';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const PHONE_PREFIXES = [
  '+420', '+421','+30', '+31', '+32', '+33', '+34', '+36', '+39',
  '+40', '+41', '+43', '+44', '+45', '+46', '+47', '+48', '+49', '+90',
  '+351', '+352', '+353', '+354', '+355', '+356', '+357', '+358', '+359',
  '+370', '+371', '+372', '+373', '+374', '+375', '+376', '+377', '+378',
  '+379', '+380', '+381', '+382', '+383', '+385', '+386', '+387', '+389',
  '+423', '+994', '+995',
];

export const DEFAULT_PHONE_PREFIX = PHONE_PREFIXES[0];

export const DEFAULT_COUNTRY = 'CZ';

export const REGISTRATION_STATUS = {
  notFound: 'not_found',
  inactive: 'inactive',
  incomplete: 'incomplete',
  registered: 'registered',
  unknown: 'unknown',
};

export const CONSENT_KEYS = ['vip', 'personalData'];

const MAX_E164_DIGITS = 12;

const MIN_AGE_YEARS = 15;

export const BIRTH_YEAR_FROM = dayjs().subtract(MIN_AGE_YEARS, 'year').year();
export const BIRTH_YEAR_TO = 1910;

export const YEARS = Array.from(
  { length: BIRTH_YEAR_FROM - BIRTH_YEAR_TO + 1 },
  (_, index) => String(BIRTH_YEAR_FROM - index),
);


export const formatZip = (value) =>
  digitsOnly(value).slice(0, 5).replace(/(\d{3})(?=\d)/, '$1 ');

export const digitsOnly = (value) => value.replace(/\D/g, '');

// mezera po kazde trojici cislic
const nationalDigits = (prefix, value) =>
  digitsOnly(value).slice(0, MAX_E164_DIGITS - digitsOnly(prefix).length);

const internationalNumber = (prefix, value) => `${prefix}${nationalDigits(prefix, value)}`;

export const formatPhone = (prefix, value) => {
  const digits = nationalDigits(prefix, value);

  if (!digits) return '';

  const asYouType = getAsYouType();
  internationalNumber(prefix, digits).split('').forEach((char) => asYouType.addChar(char));

  const formatted = asYouType.number() || '';

  return formatted.startsWith(prefix) ? formatted.slice(prefix.length).trim() : digits;
};

export const isPhoneValid = (prefix, value) =>
  parsePhoneNumber(internationalNumber(prefix, value)).valid;

export const toPhoneE164 = (prefix, value) =>
  parsePhoneNumber(internationalNumber(prefix, value)).number?.e164 ?? '';

const BIRTH_DATE_FORMAT = 'YYYY-M-D';

const birthDate = (year, month, day) =>
  dayjs(`${year}-${month}-${day}`, BIRTH_DATE_FORMAT, true);

const LEAP_YEAR = 2000;

// dokud neni znamy mesic a rok, nabizime plnych 31 dnu.
export const daysInMonth = (year, month) =>
  month ? birthDate(year || LEAP_YEAR, month, 1).daysInMonth() : 31;

const isTooYoung = (year, month, day) =>
  Boolean(year) &&
  birthDate(year, month || 1, day || 1).isAfter(dayjs().subtract(MIN_AGE_YEARS, 'year'), 'day'); 
  
export const dayOptions = (year, month) =>
  Array.from({ length: daysInMonth(year, month) }, (_, index) => {
    const day = String(index + 1);
    return { value: day, label: day, disabled: isTooYoung(year, month, day) };
  });

export const isBirthDateValid = (year, month, day) =>
  Boolean(year && month && day) && birthDate(year, month, day).isValid();

// zakaznikovi musi byt vice nez 15 let
export const isOldEnough = (year, month, day) =>
  isBirthDateValid(year, month, day) && !isTooYoung(year, month, day);

// pri 31. nelze vybrat unor, pri 29. unoru nelze vybrat neprestupny rok
// v nejmladsim rocniku nejde vybrat datum po dni 15. narozenin
export const isMonthAllowed = (year, month, day) =>
  (!day || Number(day) <= daysInMonth(year, month)) && !isTooYoung(year, month, day);

export const isYearAllowed = (year, month, day) =>
  (!month || !day || isBirthDateValid(year, month, day)) && !isTooYoung(year, month, day);

export const toIsoDate = (year, month, day) =>
  isBirthDateValid(year, month, day) ? birthDate(year, month, day).format('YYYY-MM-DD') : '';
